import { AxiosError } from 'axios';
import { useState, useRef } from 'react';
import toast from 'react-hot-toast';

import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../models/https';
import useHttps from './useHttps';

// Type definition for the request payload
export interface ResetPasswordData {
  password: string;
  b64uid: string;
  b64token: string;
}

const useResetPswdInstitution = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [completed, setCompleted] = useState(false);

  const processedPayloads = useRef<Set<string>>(new Set());

  const onResetPasswordError = (err: AxiosError<ErrorHttpResponse>) => {
    console.log('onResetPasswordError');
    toast.error(err?.response?.data?.message ?? 'Failed to reset password.');
  };

  const onResetInstitutionPassword = (_: SuccessHttpResponse<any>) => {
    toast.success('Password reset successfully!');
    localStorage.removeItem('resetData');
    setCompleted(true);
  };

  const resetInstitutionPassword = (password: string) => {
    const resetData = localStorage.getItem('resetData');
    if (!resetData) {
      toast.error('Reset data is missing. Please try again.');
      return;
    }

    const { b64uid, b64token } = JSON.parse(resetData);

    const payload: ResetPasswordData = { password, b64uid, b64token };
    const payloadKey = JSON.stringify(payload);

    if (processedPayloads.current.has(payloadKey)) {
      console.log('Password reset request already processed.');
      return;
    }

    processedPayloads.current.add(payloadKey);

    const url: HttpConfig = {
      url: 'auth-service/institution/reset-password',
      method: 'patch',
      data: payload,
    };

    request(
      url,
      (response) => {
        onResetInstitutionPassword(response);
        processedPayloads.current.add(payloadKey);
      },
      setLoading,
      (error) => {
        onResetPasswordError(error);
        processedPayloads.current.delete(payloadKey);
      }
    );
  };

  return {
    loading,
    resetInstitutionPassword,
    completed,
  };
};

export default useResetPswdInstitution;
